import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { StatesModel } from 'client/data/models/states';
import { CmsModel } from 'client/data/models/cms';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { getModelState } from 'client/data/luckdragon/model';
import { parseContent } from 'client/data/cms/content';
import { EdmundsCpaNoAdhesionDecorator } from 'site-modules/shared/pages/decorators/edmunds-cpa-no-adhesion';
import { DataPrivacyRequest } from 'site-modules/data-privacy-request/pages/data-privacy-request/data-privacy-request';
import { decoratorParams } from 'site-modules/shared/pages/decorators/decorator-params';

export const pageDefinitionConfiguration = {
  name: 'data_privacy_request',
  category: 'data_privacy_request',
  component: DataPrivacyRequest,
  preload: store => {
    const preloader = new ModelPreloader(store);
    preloader.resolve('allStateCodes', StatesModel);
    preloader.resolve('content["data-privacy-request/index"]', CmsModel);

    return preloader.load();
  },
  decorator: decoratorParams(EdmundsCpaNoAdhesionDecorator, { withAiLink: false }),
  seo: state => {
    const modelState = getModelState(state);
    const content = modelState.get('content["data-privacy-request/index"]', CmsModel);
    const parsedContent = parseContent(content);
    return {
      title: parsedContent.metadata('titleTag').value(),
      description: parsedContent.metadata('metaDescription').value(),
      canonical: parsedContent.metadata('canonical').value(),
      robots: {
        noFollow: true,
        noIndex: true,
      },
    };
  },
};

export default pageDefinition(pageDefinitionConfiguration);
